import type { UpdateTermRequest } from '@/api/generated/schemas';
import type { TermDetailFormValues } from './termDetailFormSchema';

/** Transformace hodnot formuláře editace termínu na API request `UpdateTerm`. */
export function toUpdateTermRequestBody(values: TermDetailFormValues): UpdateTermRequest {
  return {
    code: values.code.trim(),
  };
}
